import React from 'react';

const todoItem = (props) =>{
    return(
        <div onClick={()=>props.onChecked(props.id)}  >
            <li> {props.text} </li>
        </div>
    )
}

export default todoItem;